module.exports = __webpack_public_path__ + "static/media/shop-profile-default.5bfdf40a.svg";